import { headers } from "../utils/utils";
const useMensajeStore = defineStore("mensaje", () => {
  // stados
  const mensaje = ref({
    id: null,
    mensaje: "",
    chat_id: null,
    rol: 1, // 1 => usuario, 2 => asistente
    data: null,
    respondido: true,
    chat: null,
    archivos: [],
    integrante_id: null,
    oferta_id: null,
  });

  const mensajes = ref([]);

  // getters

  const draft = computed(() => clone(mensaje.value));

  // mutations

  const clear = () => {
    mensaje.value = {
      id: null,
      mensaje: "",
      chat_id: null,
      rol: 1, // 1 => usuario, 2 => asistente
      data: null,
      respondido: true,
      chat: null,
      archivos: [],
      integrante_id: null,
      oferta_id: null,
    };
  };

  const pushMensaje = (msj) => {
    if (msj) {
      mensajes.value.push(msj);
    }
  };

  const actualizarMensaje = (msj) => {
    let i = mensajes.value.findIndex((m) => m.id == msj.id);

    if (i != -1) {
      mensajes.value[i] = {
        ...mensajes.value[i],
        ...msj,
      };
    }
  };

  const clearMensajes = () => {
    mensajes.value = [];
  };

  // actions
  const enviarMensaje = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/mensajes/enviar-mensaje`, datos)
        .then(({ data }) => {
          if (data.result) {
            pushMensaje(data.mensaje_user);
            pushMensaje(data.mensaje_asistente);
          }
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const enviar = async (datos) => {
    try {
      let formData = new FormData();

      for (const key in datos) {
        if (key === "archivos") {
          // soportar tanto array como un solo archivo
          datos.archivos.forEach((file) => {
            formData.append("archivos[]", file);
          });
        } else {
          formData.append(key, datos[key]);
        }
      }

      // No establecer manualmente Content-Type: axios (o el navegador) debe
      // dejar que el boundary se genere automáticamente cuando se pasa FormData.
      const { data } = await axios.post(
        `/api/mensajes/enviar-mensaje`,
        formData,
        { headers }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const cargarMensajes = (chat_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/mensajes/chat/${chat_id}/fetch-data`)
        .then(({ data }) => {
          if (data.length) {
            mensajes.value = data;
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    // states
    mensaje,
    mensajes,
    // getters
    draft,
    // methods or actions
    clear,
    enviarMensaje,
    cargarMensajes,
    pushMensaje,
    actualizarMensaje,
    clearMensajes,
    enviar,
  };
});

export default useMensajeStore;
